// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"15cd87af","131":"b57d508d","203":"7e20802f","360":"87870bf2","370":"06437efa","453":"d433f9ef","514":"883a5c41","724":"0573d7c6","869":"45c979c1"}[chunkId] + ".chunk.js";
};